module.exports = __webpack_public_path__ + "img/insta.81d12d53.svg";